<template lang="pug">
div
  .term-title(:class="{'term-title-children': term.descendants_count}")
    span {{ $langTitle(term) }}
    q-icon(v-if="term.tooltip" name="info" right)
      q-tooltip(v-if="term.tooltip" content-class="bg-accent")
        .text-caption {{ term.tooltip }}
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'

export default @Component({
  props: {
    term: Object
  }
})
class DefaultTaxonomyViewComponent extends Vue {
}
</script>
<style>

</style>
